import { useState, useEffect } from "react";
import Card from "./card";
import FORMS from "../../api/services/FORMS";
import styles from "../../styles/_containers/_settings/sections.module.scss";

const SectionForms = ({ data, handleChange }) => {
  const [forms, setForms] = useState([]);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const [decl, quest] = await Promise.all([
          FORMS.list("declaration"),
          FORMS.list("questionnaire"),
        ]);
        setForms([...(decl?.data || []), ...(quest?.data || [])]);
      } catch (e) { console.error(e); }
    };
    fetchForms();
  }, []);

  return (
    <div className={styles.container}>
      <Card>
        <div className={styles.cardContainer}>
          <div className={`${styles.block} ${styles.lastBlock}`}>
            <div className={styles.title}>
              <h4>שליחת טופס/שאלון ללקוח חדש</h4>
              <div className={styles.tag}><p>חדש</p></div>
            </div>
            <p className={styles.textOne}>
              במידה ופעיל, המערכת תשלח ללקוח חדש קישור למילוי הטופס/שאלון שנבחר באופן אוטומטי
            </p>
            <div className={styles.field}>
              <label>סטטוס</label>
              <select
                name="sendFormOnClientJoin"
                value={String(data.sendFormOnClientJoin)}
                onChange={handleChange}
              >
                <option value="false">לא פעיל</option>
                <option value="true">פעיל — שלח טופס ללקוח חדש</option>
              </select>
            </div>
            {String(data.sendFormOnClientJoin) === "true" && (
              <div className={styles.field} style={{ marginTop: 10 }}>
                <label>בחר טופס/שאלון לשליחה</label>
                {forms.length === 0 ? (
                  <p style={{ fontSize: 13, color: "#94a3b8", margin: "6px 0" }}>
                    עדיין לא הוקמו טפסים/שאלונים במערכת.{" "}
                    <a href="/forms" style={{ color: "#DE1468", fontWeight: 600, textDecoration: "none" }}>
                      להקמה לחצו כאן
                    </a>
                  </p>
                ) : (
                  <select
                    name="formOnClientJoin"
                    value={data.formOnClientJoin || ""}
                    onChange={handleChange}
                  >
                    <option value="">-- בחר טופס --</option>
                    {forms.map((f) => (
                      <option key={f._id} value={f._id}>
                        {f.type === "declaration" ? "📋" : "📝"} {f.title}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SectionForms;
